import { NavigationDto } from "@/types";

export const defaultNavItems: NavigationDto[] = [
  {
    id: 23,
    title: "Home",
    url: "/home",
    target: "_self",
    cssClasses: null,
    iconUrl: null,
    iconCssClass: null,
    badgeText: null,
    badgeCssClass: null,
    requiresAuth: false,
    description: null,
    children: [],
  },
  {
    id: 24,
    title: "Features",
    url: "#",
    target: "_self",
    cssClasses: "dropdown-parent",
    iconUrl: null,
    iconCssClass: "chevron-down",
    badgeText: null,
    badgeCssClass: null,
    requiresAuth: false,
    description: null,
    children: [
      {
        id: 63,
        title: "Attendance & Time Tracking",
        url: "/attendance-time-tracking",
        target: "_self",
        cssClasses: "",
        iconUrl:
          "https://saashr-cms-media.s3.us-east-1.amazonaws.com/media/images/4dbf5371-f6a8-4cbf-bca5-d1149f8b27b9.webp",
        iconCssClass: null,
        badgeText: null,
        badgeCssClass: null,
        requiresAuth: false,
        description:
          "Track hours, shifts and leave with precision. Real-time visibility, automated overtime and payroll-ready data every cycle.",
        children: [],
      },
      {
        id: 62,
        title: "Employee Management ",
        url: "/attendance-time-tracking",
        target: "_self",
        cssClasses: "",
        iconUrl:
          "https://saashr-cms-media.s3.us-east-1.amazonaws.com/media/images/d8a252f3-d3b6-45df-9250-4e6859307ac5.webp",
        iconCssClass: null,
        badgeText: null,
        badgeCssClass: null,
        requiresAuth: false,
        description:
          "Centralise every employee record, securely. Profiles, contracts, documents and lifecycle events in one source of truth.",
        children: [],
      },
      {
        id: 64,
        title: "Payroll Management",
        url: "/performance-tracking",
        target: "_self",
        cssClasses: "",
        iconUrl:
          "https://saashr-cms-media.s3.us-east-1.amazonaws.com/media/images/18768add-663a-4c96-a42b-aa0d1d94df0b.webp",
        iconCssClass: null,
        badgeText: null,
        badgeCssClass: null,
        requiresAuth: false,
        description:
          "Run compliant, accurate payroll every cycle. Multi-country, automated and integrated with attendance and leave data.",
        children: [],
      },
      {
        id: 60,
        title: "Performance Tracking ",
        url: "/performance-tracking",
        target: "_self",
        cssClasses: "",
        iconUrl:
          "https://saashr-cms-media.s3.us-east-1.amazonaws.com/media/images/353b9a6e-b36d-4f17-8f91-0a70e6c1f0db.webp",
        iconCssClass: null,
        badgeText: null,
        badgeCssClass: null,
        requiresAuth: false,
        description:
          "Set goals, review progress and retain talent. OKRs, 360 reviews and continuous feedback in one connected platform.",
        children: [],
      },
      {
        id: 61,
        title: "Recruitment & Hiring ",
        url: "/recruitment-hiring",
        target: "_self",
        cssClasses: "",
        iconUrl:
          "https://saashr-cms-media.s3.us-east-1.amazonaws.com/media/images/88f557fe-43f5-4854-84c1-11dbea421df4.webp",
        iconCssClass: null,
        badgeText: null,
        badgeCssClass: null,
        requiresAuth: false,
        description:
          "Source, screen and hire top talent faster. A complete ATS from job posting to signed offer with AI-assisted screening.",
        children: [],
      },
    ],
  },
  {
    id: 27,
    title: "Pricing",
    url: "/pricing",
    target: "_self",
    cssClasses: null,
    iconUrl: null,
    iconCssClass: null,
    badgeText: null,
    badgeCssClass: null,
    requiresAuth: false,
    description: null,
    children: [],
  },
  {
    id: 28,
    title: "Resources",
    url: "#",
    target: "_self",
    cssClasses: "dropdown-parent",
    iconUrl: null,
    iconCssClass: "chevron-down",
    badgeText: null,
    badgeCssClass: null,
    requiresAuth: false,
    description: null,
    children: [
      {
        id: 65,
        title: "Blog",
        url: "/blog",
        target: "_self",
        cssClasses: "",
        iconUrl:
          "https://saashr-cms-media.s3.us-east-1.amazonaws.com/media/images/89193ef6-15e6-4e70-8ca1-3f75905aba9e.webp",
        iconCssClass: null,
        badgeText: null,
        badgeCssClass: null,
        requiresAuth: false,
        description:
          "Insights, trends and expert thinking for modern HR leaders, covering strategy, compliance, talent and product updates.",
        children: [],
      },
      {
        id: 66,
        title: "Client",
        url: "/clients",
        target: "_self",
        cssClasses: "",
        iconUrl:
          "https://saashr-cms-media.s3.us-east-1.amazonaws.com/media/images/969212f7-2e70-4fc5-ac55-0056a3e6201f.webp",
        iconCssClass: null,
        badgeText: null,
        badgeCssClass: null,
        requiresAuth: false,
        description:
          "See how organisations across financial services, healthcare, logistics and professional services use Dabar HR every day.",
        children: [],
      },
      {
        id: 67,
        title: "About Us",
        url: "/about",
        target: "_self",
        cssClasses: "",
        iconUrl:
          "https://saashr-cms-media.s3.us-east-1.amazonaws.com/media/images/6151cfbc-bc83-4f2f-9730-6abdc16430b7.webp",
        iconCssClass: null,
        badgeText: null,
        badgeCssClass: null,
        requiresAuth: false,
        description: null,
        children: [],
      },
    ],
  },
  {
    id: 32,
    title: "Contact",
    url: "/contact",
    target: "_self",
    cssClasses: null,
    iconUrl: null,
    iconCssClass: null,
    badgeText: null,
    badgeCssClass: null,
    requiresAuth: false,
    description: null,
    children: [],
  },
];
